var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget"},[_c('BaseWidgetTitle',{attrs:{"title":_vm.tokens.widgetMarketNews.marketNews},on:{"close":function($event){return _vm.hideModal('news')}}}),_c('NewsList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }